const MainBarActiveTabsReducer = (state = {}, action) => {
    if(action.type === "MainBarActiveTabs"){
        state = { ...state , ...action.payload};
    }
    return state;
}
export default MainBarActiveTabsReducer